module.exports = __webpack_public_path__ + "static/media/user-certification-sequence.0572eda4.png";